import React from 'react';
import { browserHistory } from 'react-router';
import PropTypes from 'prop-types';
import Table from '../../../core/form/Table';
import Button from '../../../core/form/Button';

const VocabularyThemeList = (props) => (
  <Table
    fetching={props.fetching}
    pagination={props.pagination}
    onChange={props.onChange}
    columns={[
      {
        label: 'Name',
        path: 'name',
        sort: true,
        defaultSortOrder: 'ascend',
      },
      {
        label: 'Actions',
        path: 'action',
        width: '80px',
        render: (cell, row) => (
          <>
            <Button icon="edit" onClick={() => browserHistory.push(`/vocabulary-themes/${row.id}`)} />
            {row.deleted ? (
              <Button icon="check" onClick={() => props.onRestore(row)} />
            ) : (
              <Button icon="delete" onClick={() => props.onDisable(row)} />
            )}
          </>
        ),
      },
    ]}
    rows={props.vocabularyThemes}
  />
);

VocabularyThemeList.propTypes = {
  vocabularyThemes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  pagination: PropTypes.shape({
    current: PropTypes.number,
    total: PropTypes.number,
    pageSize: PropTypes.number,
  }).isRequired,
  fetching: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onRestore: PropTypes.func.isRequired,
  onDisable: PropTypes.func.isRequired,
};

export default VocabularyThemeList;
